import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import clsx from 'clsx'

const root = css`
  border: 0;
  border-top: 1px solid ${cssTheme.default.day.line};
  inline-size: 100%;
`

type Props = {
  className?: string
}

export function Divider({className}: Props): React.ReactElement {
  return <hr className={clsx(root, className)} />
}
